import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  billingList: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    color: `${theme.palette.events.textPrimary} !important`,
    "& .MuiListItem-container": {
      cursor: "pointer",
      border: `1px solid ${theme.palette.events.grayShade1}`,
      boxShadow: `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
      borderRadius: "5px",
      maxWidth: "439px",
      minHeight: "72px",
      display: "flex",
      alignItems: "center",

      "&:hover": {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },

      "& .MuiListItem-root": {
        height: "100%",
        minHeight: "inherit",
      },
    },
  },
  billingListItem: {
    height: "100%",
  },

  option: {
    color: theme.palette.events.textPrimary,
  },

  chevron: {
    color: theme.palette.events.textPrimary,
    ".MuiListItem-container:hover &": {
      color: theme.palette.primary.main,
    },
  },

  icon: {
    color: theme.palette.events.textPrimary,

    ".MuiListItem-container:hover &": {
      color: theme.palette.primary.main,
    },
  },
}));
